export const ANALYTICS_SCREEN_MANAGE_APP_VERSIONS = 'manageAppVersionsScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_DETAILS = 'manageAppDetailsScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_EDITIONS = 'manageAppEditions';
export const ANALYTICS_SCREEN_MANAGE_APP_PRICNG = 'manageAppPricingScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_PRIVACY_AND_SECURITY = 'manageAppPrivacyAndSecurityScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_ACTIVE_INSTALLS = 'manageAppActiveInstallsScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_PRIVATE_LISTINGS = 'manageAppPrivateListingsScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_DOWNLOADS = 'manageAppDownloadsScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_MARKETING = 'manageAppMarketingScreen';
export const ANALYTICS_SCREEN_MANAGE_APP_ADMIN = 'manageAppAdminScreen';